import { HOUR_HEIGHT } from './timeMath.ts'

export function HourLabels() {
  return (
    <div className="relative w-14 shrink-0 border-r border-border/60">
      {Array.from({ length: 24 }, (_, hour) => (
        <div
          key={hour}
          className="absolute right-2 -translate-y-1/2 text-right text-[11px] tabular-nums text-muted"
          style={{ top: hour * HOUR_HEIGHT }}
        >
          {hour === 0 ? '' : `${String(hour).padStart(2, '0')}:00`}
        </div>
      ))}
    </div>
  )
}
